(function () {
  app.controller('WaxGptCtrl', [
    "$scope", '$timeout', '$window', '$sce',
    function ($scope, $timeout, $window, $sce) {

      $scope.wax_gpt_url = "";
      $scope.check_ai_url = "";
      $scope.sessionId = "";
      $scope.productContext = { id: null, name: "General Assistant" };

      $scope.isOpen = false;
      $scope.is_running = false;
      $scope.messages = [];
      $scope.userInput = "";

      // Quick prompts
      $scope.quickPrompts = [
        "What's releasing soon?",
        "Where can I buy it?",
        "Is this a good buy?"
      ];

      // Session Storage Keys
      var SESSION_KEY_MSG = 'waxai_msgs',
        SESSION_KEY_CONTEXT = 'waxai_last_product_id',
        SESSION_KEY_PENDING = 'waxai_is_pending',
        SESSION_KEY_SENT_AT = 'waxai_sent_at',
        SESSION_KEY_ID = 'waxai_session_id';

      // --- 2. INITIALIZATION ---
      $scope.init = function (serverGeneratedId, productData) {
        var storedSessionId = sessionStorage.getItem(SESSION_KEY_ID);

        if (storedSessionId) {
          $scope.sessionId = storedSessionId;
        } else {
          $scope.sessionId = serverGeneratedId;
          sessionStorage.setItem(SESSION_KEY_ID, $scope.sessionId);
        }

        if (productData) {
          $scope.productContext = productData;
        }

        loadSession();
        checkAndResumePolling();
      };

      // --- 3. SESSION LOGIC ---
      function loadSession() {
        var savedMsgs = sessionStorage.getItem(SESSION_KEY_MSG);

        if (savedMsgs) {
          $scope.messages = JSON.parse(savedMsgs);

          var lastPid = sessionStorage.getItem(SESSION_KEY_CONTEXT);
          if ($scope.productContext.id && lastPid && lastPid != $scope.productContext.id) {
            $scope.messages.push({
              content: "<em>--- Switched context to: <strong>" + $scope.productContext.name + "</strong> ---</em>",
              isUser: false,
              isSystem: true,
              time: new Date().toISOString()
            });
          }
        }

        if ($scope.productContext.id) {
          sessionStorage.setItem(SESSION_KEY_CONTEXT, $scope.productContext.id);
        }

        scrollToBottom();
      }

      function saveSession() {
        sessionStorage.setItem(SESSION_KEY_MSG, JSON.stringify($scope.messages));
      }

      function checkAndResumePolling() {
        var isPending = sessionStorage.getItem(SESSION_KEY_PENDING),
          sentAt = sessionStorage.getItem(SESSION_KEY_SENT_AT);

        if (isPending === 'true' && sentAt) {
          console.log("Resuming polling from previous page...");
          $scope.is_running = true;
          pollForResponse(sentAt, 0);
        }
      }

      // --- 4. UI INTERACTION ---
      $scope.toggleSidebar = function () {
        $scope.isOpen = !$scope.isOpen;
        if ($scope.isOpen) scrollToBottom();
      };

      $scope.checkEnter = function (event) {
        if (event.which === 13 && !event.shiftKey) {
          event.preventDefault();
          $scope.send_messages();
        }
      };

      function scrollToBottom() {
        $timeout(function () {
          var el = document.getElementById('chatContainer');
          if (el) el.scrollTop = el.scrollHeight;
        }, 0);
      }

      // --- 5. SEND & POLLING LOGIC ---
      $scope.send_messages = function (text) {
        var msgText = text || $scope.userInput;
        msgText = msgText ? msgText.trim() : "";

        if ($scope.is_running || !msgText) return;

        $scope.messages.push({
          content: msgText,
          isUser: true,
          time: new Date().toISOString()
        });
        $scope.userInput = "";
        scrollToBottom();
        saveSession();

        var request_data = {
          chatInput: msgText,
          sessionId: $scope.sessionId,
          productContextId: $scope.productContext.id
        };

        $scope.is_running = true;
        sessionStorage.setItem(SESSION_KEY_PENDING, 'true');

        if ($scope.wax_gpt_url == "") return;

        // 3. Call AJAX Start
        $.ajax({
          url: $scope.wax_gpt_url,
          dataType: "json",
          contentType: 'application/json',
          type: "POST",
          data: JSON.stringify(request_data),
          success: function (rs) {
            if (rs.succeed) {
              var sentAt = rs.sent_at || new Date().toISOString();
              sessionStorage.setItem(SESSION_KEY_SENT_AT, sentAt);
              pollForResponse(sentAt, 0);
            } else {
              handleError(rs.message || "Server busy. Please try again.");
            }
          },
          error: function (xhr) {
            handleError("Network error. Please try again.");
            console.log("Error:", xhr.responseText);
          }
        });
      };

      function pollForResponse(sentAt, retryCount) {
        if (sessionStorage.getItem(SESSION_KEY_PENDING) !== 'true') {
          return;
        }

        if (retryCount > 60) {
          handleError("Server timeout. Please try again later.");
          return;
        }

        $timeout(function () {
          $.ajax({
            beforeSend: function () {
              $(".loading").hide();
              $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
              $(".loading").attr('style', 'z-index: -1 !important');
            },
            url: $scope.check_ai_url,
            dataType: "json",
            contentType: 'application/json',
            type: "POST",
            data: JSON.stringify({
              sessionId: $scope.sessionId,
              after_time: sentAt
            }),
            success: function (rs) {
              if (rs.succeed) {
                if (rs.status === 'finished') {
                  finishProcess(rs.data);
                } else {
                  pollForResponse(sentAt, retryCount + 1);
                }
              } else {
                handleError("Server error during processing.");
              }
            },
            error: function () {
              pollForResponse(sentAt, retryCount + 1);
            }
          });
        }, 2000);
      }

      function finishProcess(htmlContent) {
        $scope.is_running = false;
        sessionStorage.removeItem(SESSION_KEY_PENDING);
        sessionStorage.removeItem(SESSION_KEY_SENT_AT);
        $timeout(function () {
          $scope.messages.push({
            content: htmlContent,
            isUser: false,
            time: new Date().toISOString()
          });
          scrollToBottom();
          saveSession();
        });
      }

      function handleError(msg) {
        $scope.is_running = false;
        sessionStorage.removeItem(SESSION_KEY_PENDING);
        sessionStorage.removeItem(SESSION_KEY_SENT_AT);
        $timeout(function () {
          $scope.messages.push({
            content: "<span class='text-danger'>" + msg + "</span>",
            isUser: false,
            time: new Date().toISOString()
          });
          scrollToBottom();
          saveSession();
        });
      }

      // Exposed for the bootbox confirm callback to call on logout confirmation
      window.clearWaxGptSession = function () {
        sessionStorage.removeItem(SESSION_KEY_MSG);
        sessionStorage.removeItem(SESSION_KEY_CONTEXT);
        sessionStorage.removeItem(SESSION_KEY_PENDING);
        sessionStorage.removeItem(SESSION_KEY_SENT_AT);
        sessionStorage.removeItem(SESSION_KEY_ID);
      };
    }
  ]);
}).call(this);